import { Link } from "react-router-dom";
import "./BlogCard.css";

const BlogCard = ({ post, isDarkMode }) => {
  return (
    <article className={`blog-card ${isDarkMode ? "dark" : ""}`}>
      <h3 className="blog-card-title">
        <Link to={`/blog/${post.slug}`}>{post.title}</Link>
      </h3>

      <p className="blog-card-excerpt">{post.excerpt}</p>

      <Link
        to={`/blog/${post.slug}`}
        className="read-more"
        aria-label={`Read more about ${post.title}`}
      >
        Read more →
      </Link>
    </article>
  );
};

export default BlogCard;
